import * as React from "react";
import { SVGProps } from "react";
const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m26 6 .2.005a4.005 4.005 0 0 1 3.795 3.79L30 10v12c0 2.14-1.687 3.89-3.8 3.995L26 26H6a4.004 4.004 0 0 1-3.995-3.8L2 22V10c0-2.14 1.687-3.89 3.8-3.995L6 6h20Zm2 10H4v6c0 1.053.817 1.918 1.85 1.995L6 24h20l.15-.005a2.003 2.003 0 0 0 1.844-1.839L28 22v-6Zm0-4H4v2h24v-2Zm-2-4H6l-.15.005a2.003 2.003 0 0 0-1.844 1.839L4 10h24a2.002 2.002 0 0 0-1.85-1.995L26 8Zm-7 10H7a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCreditCard;
